import { render, staticRenderFns } from "./EditAutoDeliveryCancelColorIssue.vue?vue&type=template&id=531f091a&scoped=true&lang=pug&"
import script from "./EditAutoDeliveryCancelColorIssue.vue?vue&type=script&lang=js&"
export * from "./EditAutoDeliveryCancelColorIssue.vue?vue&type=script&lang=js&"
import style0 from "./EditAutoDeliveryCancelColorIssue.vue?vue&type=style&index=0&id=531f091a&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531f091a",
  null
  
)

export default component.exports